import type { ProjectSite } from '../api/types'
import { AddressLink } from './SiteContact'

/**
 * Stedet arbejdet foregår, når det ikke er kundens adresse.
 *
 * Bruges både på sagen (beslutning 044) og på enheden (beslutning 045) - reglen
 * og teksten skal være den samme begge steder, ellers kommer de to til at
 * betyde noget forskelligt for den, der læser dem.
 *
 * Vises kun, når der ER et eget sted; ellers er svaret "hos kunden", og kundens
 * adresse står allerede lige ved siden af. Kunne adressen ikke bestemmes, siges
 * det højt: så står sagen eller enheden nemlig ikke på kortet, og det skal man
 * kunne opdage her frem for ved at savne en nål.
 */
export function WorkSiteField({
  site,
  label = 'Arbejdet foregår',
  missingText = 'Adressen kunne ikke findes, så sagen står ikke på kortet. Ret den, hvis den er skrevet forkert.'
}: {
  site?: ProjectSite | null
  label?: string
  missingText?: string
}) {
  if (!site) return null

  const linje = [site.address, [site.postalCode, site.city].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ')

  const paaKortet = site.geocodeStatus === 'ok'

  return (
    <div>
      <div className="tiny muted">{label}</div>
      <div className="small">
        <AddressLink
          contact={{
            customerId: null,
            customerName: null,
            phone: null,
            contactPerson: null,
            address: site.address ?? null,
            postalCode: site.postalCode ?? null,
            city: site.city ?? null
          }}
        />
      </div>
      {!paaKortet && (
        <div className="tiny" style={{ color: '#B45309' }}>
          {site.geocodeStatus === 'ambiguous' || site.geocodeStatus === 'not_found'
            ? missingText
            : 'Adressen er ikke slået op endnu.'}
        </div>
      )}
      {/* Ramte opslaget en anden skrivemåde, skal man kunne se hvad nålen står på. */}
      {paaKortet && site.matchedAddress && site.matchedAddress !== linje && (
        <div className="tiny muted">På kortet: {site.matchedAddress}</div>
      )}
    </div>
  )
}
